import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ApiDocsPageComponent } from '../component/page/api-docs-page/api-docs-page.component';
import { APIInformationPageComponent } from '../component/page/api-information-page/api-information-page.component';
import { ApiReferenceMockScreenPageComponent } from '../component/page/group/api-docs/api-reference-mock-screen-page/api-reference-mock-screen-page.component';
import { NDCHighLevelRoadmapPageComponent } from '../component/page/ndc-high-level-roadmap-page/ndc-high-level-roadmap-page.component';
import { NDCDevelopmentRoadmapPageComponent } from '../component/page/ndc-development-roadmap-page/ndc-development-roadmap-page.component';
import { NDCOfferManagementCapabilitiesPageComponent } from '../component/page/ndc-offer-management-capabilities-page/ndc-offer-management-capabilities-page.component';
import { NDCOrderManagementCapabilitiesPageComponent } from '../component/page/ndc-order-management-capabilities-page/ndc-order-management-capabilities-page.component';
import { NdcProductApiRoadmapPageComponent } from '../component/page/ndc-product-api-roadmap-page/ndc-product-api-roadmap-page.component';
import { NdcRegistrationPageComponent } from '../component/page/ndc-registration-page/ndc-registration-page.component';

const routes: Routes = [
  { path: 'api/info', component: APIInformationPageComponent },
  { path: 'start/ndc-registrations', component: NdcRegistrationPageComponent },
  { path: 'start/build-and-test-the-api', component: NdcRegistrationPageComponent },
  { path: 'start/get-certified-and-go-live', component: NdcRegistrationPageComponent },
  { path: 'capability/ndc-high-level-roadmap', component: NDCHighLevelRoadmapPageComponent },
  { path: 'capability/ndc-monthly-releases', component: NDCHighLevelRoadmapPageComponent },
  { path: 'capability/ndc-offer-management', component: NDCOfferManagementCapabilitiesPageComponent },
  { path: 'capability/ndc-order-management', component: NDCOrderManagementCapabilitiesPageComponent },
  { path: 'capability/new-feature-request', component: NDCHighLevelRoadmapPageComponent },
  { path: 'developer/ndc-product-api-roadmap', component: NdcProductApiRoadmapPageComponent },
  { path: 'developer/api-documentation', component: ApiDocsPageComponent },
  { path: 'developer/offer-management-flows', component: ApiDocsPageComponent },
  { path: 'developer/order-management-flows', component: ApiDocsPageComponent },
  { path: 'developer/disruption-handling', component: ApiDocsPageComponent },
  { path: 'mockScreen', component: ApiReferenceMockScreenPageComponent },
  { path: 'capability/ndc-21.3-development-roadmap', component: NDCDevelopmentRoadmapPageComponent }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppApiInfoRoutingModule {}
